import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BackgroundProvider } from "./BackgroundContext";
import { NotificationProvider } from "./NotificationContext";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enTranslations from "./locales/en.json";
import thTranslations from "./locales/th.json";
import esTranslations from "./locales/es.json";
import frTranslations from "./locales/fr.json";
import deTranslations from "./locales/de.json";
import zhTranslations from "./locales/zh.json";
import jaTranslations from "./locales/ja.json";
import koTranslations from "./locales/ko.json";
import hiTranslations from "./locales/hi.json";
import elTranslations from "./locales/el.json";
import trTranslations from "./locales/tr.json";

// Initialize i18next
i18n
  .use(LanguageDetector) // Detect user language from browser
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources: {
      en: enTranslations,
      th: thTranslations,
      es: esTranslations,
      fr: frTranslations,
      de: deTranslations,
      zh: zhTranslations,
      ja: jaTranslations,
      ko: koTranslations,
      hi: hiTranslations,
      el: elTranslations,
      tr: trTranslations,
    },
    fallbackLng: "en", // Fallback language if detection fails
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Order of language detection methods
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache user language preference
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BackgroundProvider>
      <App />
    </BackgroundProvider>
  </React.StrictMode>,
);
